import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "ActAccessModal"
}
const _hoisted_2 = { class: "ActAccessContentBlock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_act_navigation = _resolveComponent("act-navigation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ActAccessHeaderBlock" }, [
      _createElementVNode("h2", null, "Give Access")
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.ComponentForActiveStep), null, {
        default: _withCtx(() => [
          _createVNode(_component_act_navigation)
        ]),
        _: 1 /* STABLE */
      }))
    ])
  ], 512 /* NEED_PATCH */))
}